import clsx from 'clsx'

import { FeedbackTextProps } from './FeedbackText.types'

export const FeedbackText = (props: FeedbackTextProps) => {
  const { children, className, isInvalid, ...restProps } = props

  const classNames = clsx(
    'FeedbackText',
    isInvalid && 'FeedbackText-invalid',
    className,
  )

  return (
    <span className={classNames} {...restProps} role="alert">
      {children}
    </span>
  )
}
